import { buildLink } from '@amazeelabs/react-framework-bridge/gatsby';
import { MenuItem } from '@nuklear9/meta';

export const buildMenu = (
  menu: Array<MenuItemFragment> = [],
): Array<MenuItem> =>
  menu.map((item) => ({
    id: item.id,
    title: item.label,
    Link:
      item.url.length > 0
        ? buildLink({ href: item.url, partiallyActive: true })
        : undefined,
  }));
